import Blocks from "@/components/blocks/Blocks";
import Layout from "components/Layout";
import { site } from "config";
import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";
import { graphQlClient } from "lib/graphql-client.js";
import { pagePathsQuery, pageQuery } from "lib/graphql/dynamic-page-queries";
import { findAndReplaceObjectKeys } from "utils/helpers/object-processing";
import styles from "../slug.module.scss";

export default function DynamicPage({ pageData, layoutData }) {
  const SEO = {
    ...pageData?.seo,
    canonicalURL: `${site}${
      !!pageData?.page_type ? "/" + pageData?.page_type : ""
    }/${pageData?.slug}`,
  };

  return (
    <Layout layoutData={layoutData} seo={SEO}>
      <main className={`variable-container ${styles.page}`}>
        <Blocks content={pageData?.content_blocks} />
      </main>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const { slug } = context.params;

  const client = graphQlClient();

  const pageResponse = await client.query({
    query: pageQuery,
    variables: {
      slug,
    },
  });

  const pageAttributes = pageResponse.data.pages[0]?.data?.attributes;

  const objectKeyRegex = new RegExp(/(___).*/gm);
  const content_blocks = pageAttributes?.content_blocks?.map((block) =>
    findAndReplaceObjectKeys(block, objectKeyRegex, "")
  );

  const pageData = {
    ...pageAttributes,
    content_blocks: content_blocks ?? null,
  };

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();
  return {
    props: {
      pageData,
      layoutData,
    },
  };
}

export async function getStaticPaths() {
  const client = graphQlClient();

  const variables = {
    pageType: "about",
  };

  const pageResponse = await client.query({
    query: pagePathsQuery,
    variables,
  });

  const paths = pageResponse.data.pages.map((page) => ({
    params: { slug: page.data.attributes.slug },
  }));

  return {
    paths,
    fallback: false,
  };
}
